import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { IoMdMove } from "react-icons/io";
import Input from "../../../Common/Input/Input";
import UploadImageIcon from "../../../Common/SvgIcons/CommonIcons/UploadImageIcon";
// import CrossIcon from "../../../Common/SvgIcons/SocialIcons/CrossIcon";
import DeleteIcon from "../../../Common/SvgIcons/TableIcons/DeleteIcon";
import EditIcon from "../../../Common/SvgIcons/TableIcons/EditIcon";
import { useSelector } from "react-redux";
import Tooltip from "../../../Common/ToolTip/Tooltip";
import classes from "./AddQuizQuestionArr.module.scss";
import { FormattedMessage } from "react-intl";

const AddQuizQuestionArr = ({
  questionsFields,
  questionListWatch,
  errors,
  activeQuestionIndex,
  setActiveTab,
  setActiveQuestionIndex,
  reference,
  snapshot,
  shotclassType,
  handleThumbnailSelect,
  isDistributed,
  trigger,
  isValid,
  setIsEditQuestion,
  handleDeleteQuizQuestion,
  ...rest
}) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const getListStyle = (isDraggingOver) => ({
    marginBottom: isDraggingOver ? "4.6rem" : undefined,
    // marginTop: isDraggingOver ? "2rem" : "auto",
  });

  return (
    <div
      className={classes.addQuizQuestionArr__questionFields}
      ref={reference}
      style={getListStyle(snapshot.isDraggingOver)}
      {...rest}
    >
      {questionsFields.map((question, index, questionArr) => {
        return (
          <React.Fragment key={question.id}>
            {activeQuestionIndex === index ? (
              <div
                className={
                  classes.addQuizQuestionArr__questionFields__questionField
                }
              >
                <Input
                  name={`QuestionsList.${index}.Question`}
                  label="Write Question"
                  labelMsg="(Max : 250 Characters)"
                  placeholder="Enter Quiz Question"
                  labelColor="light"
                  error={errors?.QuestionsList?.[index]?.Question?.message}
                  errorPosition="absolute"
                  required={true}
                  type="textarea"
                  disabled={shotclassType === "view"}
                  maxLength={250}
                  onChange={() => {
                    if (
                      errors?.QuestionsList?.message ||
                      errors?.QuestionsList?.[activeQuestionIndex]?.Question
                        ?.message
                      // !isValid
                    ) {
                      trigger([`QuestionsList`]);
                    }
                  }}
                />
                <Input
                  type="file"
                  name={`QuestionsList.${index}.QuestionImage`}
                  label="Add Image"
                  placeholder=" "
                  labelColor="light"
                  accept=".jpeg,.png,.bmp,.jpg"
                  error={errors?.QuestionsList?.[index]?.QuestionImage?.message}
                  errorPosition="absolute"
                  hidden={true}
                  fileInputIcon={UploadImageIcon}
                  width={10}
                  fileInputButtonWidth={8}
                  fileInputName={
                    questionListWatch?.[index]?.QuestionImage?.FileName
                  }
                  handleClickFileButton={() =>
                    handleThumbnailSelect(
                      `QuestionsList.${index}.QuestionImage`
                    )
                  }
                  // gap={index === 0 ? 3.3 : 1.1}
                  gap={
                    // index === 0
                    //   ? // ? questionListWatch?.[0]?.QuestionImage?.FileName
                    //     //   ? 1.5
                    //     3.3
                    //   : // : questionListWatch?.[index]?.QuestionImage?.FileName
                    // ? 0
                    1.1
                  }
                  disabled={shotclassType === "view"}
                />
                {index !== 0 && !isDistributed && (
                  <Tooltip content="Delete" direction="bottom">
                    <span
                      onClick={(e) => {
                        if (shotclassType !== "view") {
                          handleDeleteQuizQuestion(index, question?.ID);
                        }
                      }}
                      className={
                        classes.addQuizQuestionArr__questionFields__questionField__removeIcon
                      }
                    >
                      <DeleteIcon fill={colors.theme} />
                    </span>
                  </Tooltip>
                )}
                {index === activeQuestionIndex &&
                  !errors?.QuestionsList?.[index]?.QuestionImage?.message &&
                  !errors?.QuestionsList?.[index]?.Question?.message && (
                    <div
                      className={
                        classes.addQuizQuestionArr__questionFields__questionField__error
                      }
                    >
                      {errors?.QuestionsList?.message}
                    </div>
                  )}
              </div>
            ) : (
              <Draggable
                key={`QuizQuestion[${index}]`}
                draggableId={`quiz-question-${index}`}
                index={index}
              >
                {(provided, snapshot) => (
                  <div
                    className={
                      classes.addQuizQuestionArr__questionFields__questionField
                    }
                    key={question.id}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                  >
                    <div
                      className={
                        classes.addQuizQuestionArr__questionFields__questionField__question
                      }
                    >
                      {index + 1 + ". " + questionListWatch?.[index]?.Question}
                    </div>
                    {activeQuestionIndex === -1 && (
                      <div
                        className={
                          classes.addQuizQuestionArr__questionFields__questionField__options
                        }
                      >
                        <Tooltip content={<FormattedMessage id="MYCLASS_EDIT" />} direction="bottom">
                          <div
                            onClick={() => {
                              setIsEditQuestion(true);
                              setActiveQuestionIndex(() => index);
                              setActiveTab(
                                () =>
                                  questionListWatch?.[index]?.ActiveQuestionType
                              );
                            }}
                            className={
                              classes.addQuizQuestionArr__questionFields__questionField__options__icon
                            }
                          >
                            <EditIcon />
                          </div>
                        </Tooltip>
                        {!isDistributed && (
                          <Tooltip content={<FormattedMessage id="MYCLASS_DELETE" />} direction="bottom">
                            <div
                              onClick={() => {
                                if (shotclassType !== "view") {
                                  handleDeleteQuizQuestion(index, question?.ID);
                                }
                              }}
                              className={
                                classes.addQuizQuestionArr__questionFields__questionField__options__icon
                              }
                            >
                              <DeleteIcon />
                            </div>
                          </Tooltip>
                        )}
                        {shotclassType !== "view" && (
                          <Tooltip content="Move" direction="bottom">
                            <div
                              className={
                                classes.addQuizQuestionArr__questionFields__questionField__options__move
                              }
                              {...provided.dragHandleProps}
                            >
                              <IoMdMove />
                            </div>
                          </Tooltip>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </Draggable>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default AddQuizQuestionArr;
